import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Ensures user is on a valid tab for a dynamic route.
export default function useValidateTab(activeTab: string, tabs: string[]) {
  const navigate = useNavigate();

  useEffect(() => {
    if (tabs.includes(activeTab as string)) return;

    const splitURL = window.location.pathname.split("/");
    splitURL[splitURL.length - 1] = tabs[0];

    navigate(splitURL.join("/"), { replace: true });
  }, [tabs]);
}
